export const performanceEn = {
  performanceNew: {
    to: "to",
    Last7days: "Last 7 days",
    AttendanceStatus: "Attendance Status",
    AttendanceTime: "Attendance Time",
    quicklink: "quick link",
    OPlog: "OP log",
    precomplete: "pre-complete",
    inbound: "inbound",
    bound: "bound",
    APIcall: "API call",
    softphonecall: "softphone call",
    stopCollection: "stop collection",
    cancelStopCollection: "cancel stop collection",
    selectDate: "select date",
    isSureCancel: "Are you sure to cancel the suspension of collection?"
  },
  warningLetter: {
    warningletters: 'List of warning letters',
    Download: 'Download',
    notDownloaded: "haven't downloaded",
    alreadyDownloaded: 'already download',
    alreadySended: 'already send',
    sendSuccessfully: 'sending Successfully',
    pleaseDownloadFirstly: 'Pls download firstly',
  },
  urgeLetter: {
    urgeletter: 'Collection letter',
    Download: 'Download',
    selectUrgeLetter: 'Please select template',
  },
  relation: {
    companyPhone: "Company phone number",
    person2: "person 2",
    person3: "person 3",
    self: "self",
    role: "Role",
    person1: "person 1",
    DispalyNum: "Dispaly Num",
    DestNum: "Dest Num",
    BillID: "Bill ID",
    Direction: "Direction",
    IsnotConnect: "Is/not Connect",
    OnboardTime: "Onboard Time",
    WAContext: "Send Content(WA)",
    WaitingDuration: "Waiting Duration"
  },
  CallRecordQuery: {
    RecordingMethod: "Recording Method",
    RecordingFile: "Recording file",
    Supplier: "Supplier"
  },
  RiskReport: {
    RiskReport: "Risk Report",
    Risk: "Risk"
  },
  CommonParam: {
    ParameterName: "Parameter Name",
    ParameterDescription: "Parameter description",
    OperatingTime: "Operating time",
    Operator: "Operator",
    ParameterValue: "Parameter Value"
  },
  salaryReport: {
    timelimit: "time limit",
    whetherthenewstaffofthemonth: "whethe rthe new staff of the month",
    basesalary: "base salary",
    isthefirstofthestaffIDnumber5: "is the first of the staff ID number 5",
    basicdailywage: "basic daily wage",
    actualbasicsalary: "actual basic salary",
    staffcreatetime: "staff create time",
    CurrentCycle: "Current Cycle",
    LastCycle: "Last Cycle",
    CurrentMonth: "Current Month",
    Wagetimerange: "Wage time range"
  },
  applicationReview: {
    ApplyReason: "Apply Reason",
    ApproveOpinion: "Approve Opinion",
    Approve: "Waiting for review",
    Passed: "Pass",
    Refused: "Approve Refuse",
    Failed: "Deduct Fail",
    Successful: "Deduct Success",
    ApproveRemark: "Approve Remark",
    Detailsofexemption: "Details of exemption",
    IsRepay: "Whether there is repayment",
    Invalid: "Invalid",
    completeTicket: 'Complete ticket'
  },
  OrderStatus: {
    PartiallyCompleted: 'Partially Completed',
    PrecompleteStatus: 'Prepayment completed status',
    beyondCompareSubmitFailed: 'Exceed the deductible amount, Submit failed',
    manuoverdueDays: 'Case escalation has been initiated, the results will be synchronized to the group chat after 10 minutes.',
    manuoverdueDaysFailed: 'Upgrade failed, please try again'
  },
  QueryDimension: 'Query Dimension',
  Call: 'Call',
  FirstCall: 'First Call',
  Totalcall: 'Total call',
  // "First login time today": "今天第一次登录时间",
  // "Last update time": "上次更新时间",
  // 'Assign Num': "分配数",
  // 'Group KPI repay amount': "小组目标回款金额",
  // 'KPI repay amount': "目标回款金额",
  // "login time": "登录时间",
  // "Half a month": "半月",
  // "That day": "当日",
  // "Target amount of returns": "目标回款金额",
  // "Tiempo de PTP is incorrect, please fill in again": "承诺还款时间不正确，请重新填写",
};
